var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"title mb-7"},[_vm._v(_vm._s(_vm.$t('headerUserCenterNavMyFavorites')))]),_c('CardList',{directives:[{name:"scroll",rawName:"v-scroll",value:(_vm.onScroll),expression:"onScroll"}],attrs:{"list":_vm.list,"type":"collect","owerfrom":"market","isShowLoading":_vm.isShowLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }